module.exports = __webpack_public_path__ + "static/media/star-full.a7d8768e.svg";